import React, { useEffect, useRef, useState, useMemo } from 'react'
import { Reports as ReportsAPI } from '../../api/services/next'
import { Menu, Dropdown, Grid, List } from 'semantic-ui-react'
import _ from 'lodash'
import { endpoint } from '../../api/http'
import { useTextResources } from '../../language';
import PropTypes from 'prop-types'

const Reports = ({ initialSrc }) => {
    const [reports, setReports] = useState([])
    const iframeRef = useRef()
    const [src, setSrc] = useState(initialSrc)
    const text = useTextResources();

    useEffect(() => {
        (async () => {
            try {
                const currentHotelId = window.optima.user.CurrentHotel.Id
                const reports = await ReportsAPI.GetReports({ HotelId: currentHotelId })
                setReports(reports)

            } catch (error) {
                console.error(error)
            }
        })()

    }, [])

    useEffect(() => {
        if (iframeRef.current) {
            if (src) {
                const url = new URL(window.location);
                url.searchParams.set('reportURL', src);
                window.history.pushState({}, '', url);
            }
            iframeRef.current.src = src || "about:blank"
        }
    }, [iframeRef, src])

    const orderedItems = useMemo(
      () =>
        _.groupBy(
          _.orderBy(reports, ['Category.DisplayOrder', 'Id']),
          'Category.TranslationResourceKey'
        ),
      [reports]
    );
     

    const ReportsMenu = () => <Menu size="small" activeIndex={-1} compact secondary items={
        _.concat(
            _.map(orderedItems, (items, category) => {
                return <Dropdown simple key={category} item text={text(category)} active="false">
                    <Dropdown.Menu>
                        {
                            _.map(items, item => {
                                return <Dropdown.Item key={item.Id} text={text(item.TranslationResourceKey)} value={item.Url}
                                    onClick={() => setSrc(item.Url.replace('/Silverbyte.Optima2.Webshell/', endpoint))}
                                />
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            })
        )
    } />

    useEffect(() => {
        if (reports?.length) {
            window.optima.commands.registerCustomToolbarComponent(ReportsMenu, true)
        }
    }, [reports])

    return (
        <div style={{ flex: 1, display: "flex" }}>
            {src ? <iframe style={{ flex: 1, border: 0 }} ref={iframeRef}></iframe> :
                <Grid columns="equal">
                    {
                        _.map(orderedItems, (items, category) => {
                            return (
                                <Grid.Column key={category}>
                                    <List selection divided verticalAlign='middle'>
                                        <List.Header as="h4">{text(category)}</List.Header>
                                        {
                                            items.map(item=>{
                                                return (
                                                    <List.Item as='a' style={{color: "#000000b3"}} key={item.Id} onClick={() => setSrc(item.Url.replace('/Silverbyte.Optima2.Webshell/', endpoint))}>
                                                        {text(item.TranslationResourceKey)}
                                                    </List.Item>
                                                )
                                            })
                                        }
                                    </List>
                                </Grid.Column>
                            )
                        })
                    }
                </Grid>}
        </div>
    )
}
Reports.propTypes = {
    initialSrc: PropTypes.string
}
export default Reports